import { ActivationPayload, AuthenticationPayload, LoginResponse } from '@dev/ee-api/ee-api-models';
import { AxiosPromise } from 'axios';

import { request } from './request';

export const authWithDisposableToken = (Token: string): AxiosPromise<LoginResponse> => {
    const { Auth } = request();
    return Auth.authDisposableloginPost({ Token });
};

export const resend2FACodePOST = (payload: AuthenticationPayload): AxiosPromise<void> => {
    const { Auth } = request();
    return Auth.authTwofactorCodePost(payload);
};

export const resendActivationEmail = (payload: ActivationPayload): AxiosPromise<void> => {
    const { Auth } = request();
    return Auth.authActivationPost(payload);
};
